import { CopyToClipboardButton } from 'components';
import {
  ReleaseButton,
  ReleaseButtonContainer,
} from 'components/SongActionButtons/components/ReleaseButton';
import StudioButton from 'components/SongActionButtons/components/StudioButton';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { getSongDetailsURL } from 'services/helpers/song';
import { VegaSong } from 'services/store/ai/types';
import { DisplayAddToLibraryIcon } from 'components/SongActionButtons/components/DisplayAddToLibrary/DisplayAddToLibraryIcon';
import DownloadSection from 'components/SongActionButtons/components/DownloadSection';
import {
  StyledReleaseButtonSlotContainer,
  StyledStudioButtonSlotContainer,
  StyledTrackAddToLibraryContainer,
  StyledTrackCopyLinkContainer,
  StyledTrackDownloadContainer,
} from 'pages/AIMusicGenerator/components/Track/components/TrackContent/components/ActionButtons/DesktopTrackActionButtons/styled';

interface DesktopTrackActionButtonsProps {
  song: VegaSong;
  location: AnalyticsEventLocation;
  isInLibrary: boolean;
  addToLibraryHandler: () => void;
  removeFromLibrary: () => void;
}

const DesktopTrackActionButtons = ({
  song: { id, title, songType },
  location,
  isInLibrary,
  addToLibraryHandler,
  removeFromLibrary,
}: DesktopTrackActionButtonsProps) => (
  <>
    <StyledStudioButtonSlotContainer>
      <StudioButton
        songId={id}
        title={title}
        isAIGenerated
        location={location}
      />
    </StyledStudioButtonSlotContainer>

    <StyledReleaseButtonSlotContainer>
      <ReleaseButtonContainer songId={id} location={location}>
        <ReleaseButton songId={id} />
      </ReleaseButtonContainer>
    </StyledReleaseButtonSlotContainer>

    <StyledTrackCopyLinkContainer>
      <CopyToClipboardButton text={getSongDetailsURL(id, title)} />
    </StyledTrackCopyLinkContainer>

    <StyledTrackAddToLibraryContainer>
      <DisplayAddToLibraryIcon
        isInLibrary={isInLibrary}
        removeFromLibrary={removeFromLibrary}
        addToLibrary={addToLibraryHandler}
      />
    </StyledTrackAddToLibraryContainer>
    <StyledTrackDownloadContainer>
      <DownloadSection
        songId={id}
        songType={songType}
        location={location}
        addToLibrary={addToLibraryHandler}
      />
    </StyledTrackDownloadContainer>
  </>
);

export default DesktopTrackActionButtons;
